import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";
import logoDark from "@/assets/logo.png";
import logoLight from "@/assets/logo-light.png";

interface BrandMarkProps {
  className?: string;
}

/** The sksenq logo tile with its wordmark. */
export const BrandMark = ({ className }: BrandMarkProps) => {
  const { resolvedTheme } = useTheme();

  return (
    <span className={cn("flex items-center gap-2.5 text-[21px] font-semibold tracking-[-0.03em]", className)}>
      <img
        src={resolvedTheme === "light" ? logoLight : logoDark}
        alt=""
        width={32}
        height={32}
        className="h-8 w-8 rounded-full border-2 border-foreground/20 object-cover"
      />
      <span>sksenq</span>
    </span>
  );
};

export default BrandMark;
